import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createAuthSlice, type AuthSlice } from "./slice-type/user-slice";
import {
  createLoginModalSlice,
  type LoginModalSlice,
} from "./slice-type/login-modal-slice";
import {
  createRosterMadeSlice,
  type RosterMadeSlice,
} from "./slice-type/roster-made-slice";
import {
  createViolationVisibilitySlice,
  type ViolationVisibilitySlice,
} from "./slice-type/violation-visibility-slice";

// Slice - type
type StoreState = AuthSlice &
  LoginModalSlice &
  RosterMadeSlice &
  ViolationVisibilitySlice;

// Store - slice patten 책임 분리
const useStore = create<StoreState>()(
  persist(
    (...arg) => ({
      ...createLoginModalSlice(...arg), // Login Modal
      ...createAuthSlice(...arg), // Auth
      ...createRosterMadeSlice(...arg), // Roster Made
      ...createViolationVisibilitySlice(...arg), // Violation Visibility
    }),
    {
      name: "roster-storage", // unique name
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
      }),
      merge: (persistedState, currentState) => {
        if (
          persistedState &&
          typeof persistedState === "object" &&
          "isAuthenticated" in persistedState
        ) {
          return {
            ...currentState,
            isAuthenticated: Boolean(persistedState.isAuthenticated),
          };
        }

        return currentState;
      },
    }
  )
);

export default useStore;
